import { GEO_ZONE_LOCATION_EXCLUSION_INITIAL_STATE } from 'components/common/geo-zone-location/geoZoneLocationExclusion'
import { CONTACT_METHODS, CONTACT_METHOD_TYPES } from 'settings/constants/contacts'

import type { GeoZoneLocationExclusionFormValues } from 'components/common/geo-zone-location/geoZoneLocationExclusion'
import type { AccountLifecycleReasonApi } from 'types/api/account-lifecycle/accountLifecycle'

const { MOBILE, EMAIL } = CONTACT_METHODS
const { PERSONAL } = CONTACT_METHOD_TYPES

type NewAccountAddress = {
  line1: string
  unitNumber: string
  city: string
  state: string
  country: string
  zipCode: string
  latitude: string
  longitude: string
}

export type NewAccountFormValues = {
  accountName: string
  contact: { firstName: string; lastName: string }
  contactPhone: string
  contactEmail: string
  address: NewAccountAddress & { addressName: string }
  zones: GeoZoneLocationExclusionFormValues
  useAsBillingAddress: boolean
  billingAddress: NewAccountAddress
  billingProfileId: string
  businessUnitId: string
  sourceReasonId: string
  sourceCompetitorId: string
  note: string
}

export const NEW_ACCOUNT_INITIAL_STATE: NewAccountFormValues = {
  accountName: '',
  contact: {
    firstName: '',
    lastName: '',
  },
  contactPhone: '',
  contactEmail: '',
  address: {
    addressName: '',
    line1: '',
    unitNumber: '',
    city: '',
    state: '',
    country: '',
    zipCode: '',
    latitude: '',
    longitude: '',
  },
  zones: GEO_ZONE_LOCATION_EXCLUSION_INITIAL_STATE,
  useAsBillingAddress: true,
  billingAddress: {
    line1: '',
    unitNumber: '',
    city: '',
    state: '',
    country: '',
    zipCode: '',
    latitude: '',
    longitude: '',
  },
  billingProfileId: '',
  businessUnitId: '',
  sourceReasonId: '',
  sourceCompetitorId: '',
  note: '',
}

export const SEARCH_CUSTOMER_BY_TYPE = {
  PHONE: 'PHONE',
  EMAIL: 'EMAIL',
}

export const INITIAL_PHONE_CONTACT_METHOD = {
  methodType: MOBILE,
  methodValue: '',
  contactMethodType: PERSONAL,
  serviceNotifications: true,
  billingNotifications: false,
}

export const INITIAL_EMAIL_CONTACT_METHOD = {
  methodType: EMAIL,
  methodValue: '',
  contactMethodType: PERSONAL,
  serviceNotifications: false,
  billingNotifications: true,
}

// Shared by the field that shows the competitor and the submit that maps a rejection onto it.
export const reasonRequiresCompetitor = (reasons: AccountLifecycleReasonApi[], reasonId: string | undefined) =>
  reasons.some(reason => reason.id === reasonId && reason.requiresCompetitor)
